<template>
  <div>
    <list
      row-key="OtherId"
      ref="list"
      unit="入口成绩计算设置"
      :expand-all-row="true"
      :page="false"
      :query-params="params"
      :show-checkbox="true"
      :show-query="false"
      :get-data-func="api.list"
      size="small"
      :showQuery="false"
      class="other"
    > 
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <el-table-column prop="ExamNumber" label="考试次数" width="80" align="center" />
        <el-table-column prop="ExamRatio" label="各次数占比" min-width="180" align="center" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

import roleSelect from "@/components/sys/role/select";

export default {
  mixins: [listMixin],
  components: { list, roleSelect },
  data() {
    return {
      api: require("@/api/achieve/params/entry").default,
      params: {

      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
// .other .el-table{
//   @media screen and(min-width: 768px) {
//     width: 700px !important;
//   }
// }
// .other .filter-container{
//   @media screen and(min-width: 768px) {
//     width: 700px;
//   }
// }
</style>